import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { getIsFeatureEnabled } from "~/store/selectors/selector.configOptions";

export const RequireFeature = ({ children, redirectTo, feature }) => {
  const isFeatureEnabled = useSelector((state) => getIsFeatureEnabled(state, feature));

  return isFeatureEnabled ? children : <Navigate to={redirectTo} />;
};

RequireFeature.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.any,
  feature: PropTypes.string.isRequired,
};

RequireFeature.defaultProps = {
  redirectTo: "/not-found",
};
